// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "fareGroup__button-382sp";
var _4 = "fareGroup__button_active-guTkJ";
var _5 = "fareGroup__button_business-2Z9Ui";
var _6 = "slider__wrp-3CnJw";
var _7 = "fareGroup__slide-31e0w";
var _8 = "scroll_up-3nM5O";
var _9 = "buttons-2piNA";
var _a = "compareFaresLink-3-QMK";
export { _1 as "__esModule", _2 as "mobile", _3 as "fareGroup__button", _4 as "fareGroup__button_active", _5 as "fareGroup__button_business", _6 as "slider__wrp", _7 as "fareGroup__slide", _8 as "scroll_up", _9 as "buttons", _a as "compareFaresLink" }
export default { "__esModule": _1, "mobile": _2, "fareGroup__button": _3, "fareGroup__button_active": _4, "fareGroup__button_business": _5, "slider__wrp": _6, "fareGroup__slide": _7, "scroll_up": _8, "buttons": _9, "compareFaresLink": _a }
